import { businessDateFor } from '@/domain/businessDate';

/**
 * Everyone signs in for themselves each day: after 4 a.m. (the venue's time) whoever was
 * using the device is signed out, so the next count shows who really counted rather than
 * whoever happened to be signed in last.
 */
export const SIGN_OUT_AT = '04:00';
/** Not in the middle of something: wait until the device has been left alone this long. */
export const SIGN_OUT_IDLE_MS = 5 * 60_000;

/** True while a sign-in made at `at` still counts (same day, counting days from 4 a.m.). */
export function stillSignedIn(at: string | null, now: Date, timeZone: string): boolean {
  if (!at || Number.isNaN(Date.parse(at))) return false;
  return businessDateFor(at, timeZone, SIGN_OUT_AT) === businessDateFor(now, timeZone, SIGN_OUT_AT);
}
